export const EventPackageType = {
    EVENT: 'event',
    PACKAGE: 'package'
};